import MessageBar from './atoms/MessageBar';
import { useState, useEffect } from 'react';
import axios from 'axios';
import config from '../config';
import UploadButton from './UploadButton';

const UploadController = ({ studentId }) => {
  // BUTTON STATES
  const defaultState = {
    bc: false,
    bt: false,
    fr: false,
    hc: false,
    tr: false,
    ps: false,
  };
  const [uploadState, setUploadState] = useState(defaultState);
  const [statusMsg, setStatusMsg] = useState({
    msg: '',
    type: '',
  });

  useEffect(() => {
    // get button state
    setUploadState(defaultState);
    const buttonData = new FormData();
    buttonData.append('function', 'getbuttonstate');
    buttonData.append('studentId', studentId);

    axios
      .post(config.API, buttonData)
      .then(output => {
        if (output?.data?.response !== null) {
          output?.data?.response?.map(type => {
            setUploadState(prev => {
              return { ...prev, [type]: true };
            });
          });
        }
      })
      .catch(error => {
        console.error(error);
      });
  }, [studentId]);

  //UPLOAD FUNCTION
  const handleFileUpload = (e, type) => {
    e.preventDefault();
    setStatusMsg({ msg: '', type: '' });

    const file = e.target.files[0];
    if (!file) return;

    const allowedExts = ['jpg', 'jpeg', 'png', 'pdf'];
    const ext = file.name.split('.').pop().toLowerCase();
    if (!allowedExts.includes(ext)) {
      setStatusMsg({
        msg: 'Unsupported file type. Allowed: JPG, PNG, PDF.',
        type: 'error',
      });
      document.getElementById('uploadForm').reset();
      return;
    }
    if (file.size > 5 * 1024 * 1024) {
      setStatusMsg({
        msg: 'File is too large. Max 5MB.',
        type: 'error',
      });
      document.getElementById('uploadForm').reset();
      return;
    }

    const formData = new FormData();
    formData.append('inputFile', file);
    formData.append('function', 'upload');
    formData.append('studentId', studentId);
    formData.append('docType', type);

    axios
      .post(config.API, formData)
      .then(output => {
        if (output.data.response === 'SUCCESS') {
          setStatusMsg({
            msg: 'Success! Your file has been uploaded. You may now close this page, or continue to upload other documents.',
            type: 'success',
          });
          // CHANGE BUTTON STATE
          setUploadState(prev => {
            return { ...prev, [type]: true };
          });
        } else {
          const serverMsg =
            output?.data?.response && typeof output.data.response === 'object'
              ? output.data.response.msg
              : null;
          setStatusMsg({
            msg:
              serverMsg ||
              'Sorry, something went wrong. Your file was not uploaded. (Ensure that the filesize is below 5MB)',
            type: 'error',
          });
        }
        document.getElementById('uploadForm').reset();
      })
      .catch(error => {
        console.log(error);
      });
  };

  return (
    <div>
      <div className=' pb-6 text-center text-lg'>
        <MessageBar msg={statusMsg.msg} type={statusMsg.type} />
      </div>

      <form id='uploadForm'>
        <UploadButton
          buttonState={uploadState.bt}
          buttonType='bt'
          handleFileUpload={handleFileUpload}
        >
          Baptism Certificate
        </UploadButton>

        <UploadButton
          buttonState={uploadState.fr}
          buttonType='fr'
          handleFileUpload={handleFileUpload}
        >
          First Reconciliation Certificate (if applicable)
        </UploadButton>

        <UploadButton
          buttonState={uploadState.hc}
          buttonType='hc'
          handleFileUpload={handleFileUpload}
        >
          First Holy Communion Certificate (if applicable)
        </UploadButton>

        <UploadButton
          buttonState={uploadState.tr}
          buttonType='tr'
          handleFileUpload={handleFileUpload}
        >
          Transfer Letter from existing parish (if applicable)
        </UploadButton>

        <UploadButton
          buttonState={uploadState.ps}
          buttonType='ps'
          handleFileUpload={handleFileUpload}
          allowReplace
        >
          Material Fee Payment screenshot (If applicable)
        </UploadButton>
      </form>
    </div>
  );
};

export default UploadController;
